import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Page, Card, TableProps, Text } from 'components';

import { getCoopRelationships } from 'api/SupraController';
import { CoopRelationshipDTO } from '@bb/domain/dist/types';

import { CoopListTable } from '../../components';

const MLSStaffCoopPage: React.FC = () => {
  const [coops, setCoops] = useState<CoopRelationshipDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoopRelationships = async () => {
      const coopRelationships = await getCoopRelationships();
      setCoops(coopRelationships);
      setLoading(false);
    };

    fetchCoopRelationships();
  }, []);

  const columns: TableProps['columns'] = [
    {
      title: 'Organization',
      key: 'name',
      dataIndex: 'name',
      sorter: (
        { name: name1 }: { name: string },
        { name: name2 }: { name: string },
      ) => name1.localeCompare(name2),
      render(_, coop) {
        return (
          <StyledNameContainer>
            {`${coop.name} (${coop.label})`}
            {coop.type === 'oneWay' && (
              <StyledSubText type="secondary">
                {coop.hasPermission
                  ? 'Your keyholders can open lockboxes in this organization'
                  : 'This organization’s keyholders can open lockboxes in your organization'}
              </StyledSubText>
            )}
          </StyledNameContainer>
        );
      },
    },
    {
      title: 'Type',
      key: 'type',
      dataIndex: 'type',
      render(_, coop) {
        return coop.type === 'oneWay' ? 'One Way' : 'Two Way';
      },
      filters: [
        { text: 'One Way', value: 'oneWay' },
        { text: 'Two Way', value: 'twoWays' },
      ],
      onFilter(value, record) {
        return record.type === value;
      },
    },
  ];

  return (
    <Page
      type="filled"
      title="Auto Co-op Organizations"
      showBackButton
      fillScreenHeight
    >
      <StyledContainer>
        <Card>
          <p>
            {
              "You are cooperating with the organizations in the table below. One-way relationships grant agents access to another organization's lockboxes, but not the other way around. Two-way relationships allow agents from both organizations to share access to each other's lockboxes."
            }
          </p>
        </Card>
        <CoopListTable coops={coops} columns={columns} loading={loading} />
      </StyledContainer>
    </Page>
  );
};

export default MLSStaffCoopPage;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 24px;
  width: 50%;
  gap: 20px;
`;

const StyledSubText = styled(Text)``;

const StyledNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
